import React from "react"
import styled from "styled-components"
import {
  setColor,
  setRem,
  setShadow,
  setFlex,
  setTransition,
} from "../../style"
import Hero from "../global/Hero"
import NumberFormat from "react-number-format"
import { FormattedMessage, Link } from "gatsby-plugin-intl"

const Item = ({ className, deal }) => {
  const {
    slug = "",
    mainImage = "",
    title = "",
    subTitle = "",
    fromPrice = "",
    promotionalPrice = "",
    savingPercent = "",
  } = deal.node

  return (
    // <article className={className} onClick={() => navigate(`${slug}`)}>
    <article className={className}>
      <Link to={"/" + slug}>
        <Hero
          img={mainImage.fluid.src}
          height={40}
          bgColor="rgba(255,255,255,0.2)"
          fixed
        >
          <div className="box-title">
            <div className="left">
              <div className="title">
                {title}, <FormattedMessage id="home.vacationDeals.mexico" />
                <div className="sub">{subTitle}</div>
              </div>
            </div>
            <div className="right">
              <div className="from">
                <FormattedMessage id="deals.locationItem.from" /> <br />
                <b>$</b>
                <NumberFormat
                  value={fromPrice}
                  thousandSeparator={true}
                  displayType={"text"}
                  className="price"
                />
                <br />
                <FormattedMessage id="deals.locationItem.perCouple" />
              </div>
              <div className="only">
                <FormattedMessage id="deals.locationItem.only" /> <br />
                <b>$</b>
                {/* <span className="price">{promotionalPrice}</span> */}
                <NumberFormat
                  value={promotionalPrice}
                  thousandSeparator={true}
                  displayType={"text"}
                  className="price"
                />
                <div className="down">
                  <FormattedMessage id="deals.locationItem.down" />
                </div>
              </div>
            </div>
          </div>
        </Hero>

        <div className="bootom-box">
          <div className="left">
            <FormattedMessage id="deals.locationItem.6days" />
          </div>
          <div className="right">
            <FormattedMessage id="deals.locationItem.save" /> {savingPercent}%
            <div className="kids">
              <FormattedMessage id="deals.locationItem.2kids" />
            </div>
          </div>
        </div>
      </Link>
    </article>
  )
}

export default styled(Item)`
  background: ${setColor.mainWhite};
  margin: ${setRem(15)} 0;
  ${setShadow.light};
  ${setTransition()};
  a {
    text-decoration: none;
    color: ${setColor.mainGrey};
  }

  &:hover {
    cursor: pointer;
    filter: brightness(110%);
    ${setShadow.darkest};
    a {
      color: ${setColor.secondaryColor};
    }
  }
  .box-title {
    align-self: flex-end;
    width: 100%;
    background-color: #5555557d;
    color: ${setColor.mainWhite};
    ${setFlex({ x: "space-between", y: "stretch" })};

    .title {
      padding-left: ${setRem(5)};
      font-size: ${setRem(20)};
      text-transform: uppercase;
      font-weight: bold;
      flex-grow: 1;
      .sub {
        font-size: ${setRem(12)};
        font-weight: normal;
      }
    }
    .right {
      ${setFlex()};
      text-align: center;
      line-height: 1;
      text-transform: uppercase;
    }
    .from {
      background-color: ${setColor.primaryColor};
      font-size: ${setRem(13)};
      width: 5.5rem;
    }
    .only {
      background-color: ${setColor.secondaryColor};
      font-size: ${setRem(13)};
      line-height: 1;
      width: 5.5em;
    }
    .price {
      font-size: ${setRem(20)};
      font-weight: bold;
    }
    .down {
      font-size: ${setRem(11)};
    }
  }
  .bootom-box {
    padding: 1em;
    font-size: ${setRem(16)};
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .right {
      text-align: center;
      background: ${setColor.primaryColor};
      padding: 0.5em;
      width: 200px;
      color: ${setColor.mainWhite};
      font-size: ${setRem(20)};
      font-weight: bold;
      line-height: 1;

      .kids {
        font-size: ${setRem(12)};
        font-weight: normal;
      }
    }
  }
`
